import { render, staticRenderFns } from "./ReservierungBestellungBestaetigen.vue?vue&type=template&id=61044609"
import script from "./ReservierungBestellungBestaetigen.vue?vue&type=script&lang=ts"
export * from "./ReservierungBestellungBestaetigen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports